import { ShieldCheck, Lightbulb, Star } from "lucide-react";

const values = [
  {
    icon: ShieldCheck,
    title: "Integrity",
    description:
      "We uphold the highest standards of transparency, ethical conduct, and fiduciary responsibility in every aspect of our business. Our clients' trust is the cornerstone of everything we do.",
  },
  {
    icon: Lightbulb,
    title: "Expertise",
    description:
      "Our team brings decades of combined experience from leading global financial institutions. We leverage deep fundamental research and disciplined analysis to identify compelling investment opportunities.",
  },
  {
    icon: Star,
    title: "Service Excellence",
    description:
      "We are committed to delivering a superior client experience through responsive communication, tailored solutions, and a relentless focus on achieving optimal risk-adjusted returns.",
  },
];

const OurValues = () => {
  return (
    <section id="values" data-testid="values-section" className="py-24 sm:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A6670] mb-4 font-body" data-testid="values-overline">
            Our Ethos
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-heading" data-testid="values-title">
            Our Values
          </h2>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((value, idx) => (
            <div
              key={idx}
              className="value-card group bg-white border border-slate-200 rounded-sm p-8 sm:p-10 hover:border-[#4A6670] transition-all duration-300"
              data-testid={`value-card-${idx}`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#F8FAFC] rounded-sm mb-6 group-hover:bg-[#4A6670] transition-colors duration-300">
                <value.icon className="h-6 w-6 text-[#E87722] group-hover:text-white transition-colors duration-300" />
              </div>
              <div className="value-accent mb-6" />
              <h3 className="text-xl font-medium text-slate-900 font-heading mb-4" data-testid={`value-title-${idx}`}>
                {value.title}
              </h3>
              <p className="text-sm leading-relaxed text-slate-500 font-body" data-testid={`value-description-${idx}`}>
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurValues;
